var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard"},[_c('dashboard-pane'),((_vm.planData.hasPlan && _vm.isShowNoCredit && !_vm.hasCredit))?_c('dimmed',[((_vm.planData.hasPlan && _vm.isShowNoCredit && !_vm.hasCredit))?_c('dashboard-no-credit',{on:{"onClose":function($event){_vm.isShowNoCredit = false}}}):_vm._e()],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }